import React from 'react';

interface PDFErrorStateProps {
  message: string;
}

export const PDFErrorState: React.FC<PDFErrorStateProps> = ({ message }) => {
  return (
    <div className="flex items-center justify-center w-full h-full bg-muted/50">
      <div className="p-12 text-destructive">
        <p>{message}</p>
      </div>
    </div>
  );
};
